import { Logo } from "./Logo";
import { Navbar } from "./Navbar";
import { NavLinks } from "./NavLinks";
import { UserProfile } from "./UserProfile";
import { getFeatureFlagStatus } from "../../featureFlags";

import { Box, Center } from "@chakra-ui/react";
const nftBridgeEnabled = getFeatureFlagStatus("nftBridgeEnabled");

const AppHeader = () => (
  <Box>
    <Navbar>
      <Navbar.Brand>
        <Center marginEnd="10">
          <Logo />
        </Center>
      </Navbar.Brand>
      <Navbar.Links>
        <NavLinks isActive exact to="/">
          Home
        </NavLinks>
        <NavLinks to="/configure">Configure</NavLinks>
        <NavLinks to="/bridge">Token Bridge</NavLinks>
        {nftBridgeEnabled && <NavLinks to="/nftbridge">NFT Bridge</NavLinks>}
      </Navbar.Links>
      <Navbar.UserProfile>
        <UserProfile />
      </Navbar.UserProfile>
    </Navbar>
  </Box>
);

export default AppHeader;
